import { gql } from '@apollo/client';

export const SET_FAVORITE_SIMULATION_MUTATION = gql`
  mutation SetFavoriteSimulationForLead($leadId: ID!, $simulationId: ID!) {
    setFavoriteSimulationForLead(leadId: $leadId, simulationId: $simulationId)
  }
`;
